import { DecimalSchema } from "../../decimal";
import { REFERRAL_STATUS } from "../../referral/referral";
import { z } from "zod";

export const RefereesCountSchema = z.object({
  total: z.number(),
  lastSixMonths: z.record(z.string(), z.number()),
});
export type RefereesCountDto = z.infer<typeof RefereesCountSchema>;

export const VolumeByRefereeSchema = z.object({
  data: z.array(
    z.object({
      defiAddress: z.string(),
      totalVolumeUSD: z.number(),
    }),
  ),
  totalReferees: z.number(),
});
export type VolumeByRefereeDto = z.infer<typeof VolumeByRefereeSchema>;

export const VolumeByExchangeSchema = z.array(
  z.object({
    exchangeId: z.string(),
    totalVolumeUSD: z.number(),
  }),
);
export type VolumeByExchangeDto = z.infer<typeof VolumeByExchangeSchema>;

export const RewardsStatisticsSchema = z.object({
  totalDistributedRewards: z.number(),
  totalRewards: z.number(),
  distributedRewardsCount: z.number(),
  totalRewardsCount: z.number(),
  lastSixMonthsDistributedRewards: z.record(z.string(), z.number()),
});
export type RewardsStatisticsDto = z.infer<typeof RewardsStatisticsSchema>;

export const VolumeByReferrerSchema = z.object({
  data: z.array(
    z.object({
      defiAddress: z.string(),
      totalVolumeUSD: z.number(),
      lastWeekVolumeUSD: z.number(),
      lastMonthVolumeUSD: z.number(),
      totalRewardsUSD: z.number(),
    }),
  ),
  totalReferrers: z.number(),
});
export type VolumeByReferrerDto = z.infer<typeof VolumeByReferrerSchema>;

export const ReferrerReferreesSchema = z.array(
  z.object({
    defiAddress: z.string(),
    totalRewardsUSD: z.number(),
    splitRatio: z.number(),
  }),
);
export type ReferrerReferreesDto = z.infer<typeof ReferrerReferreesSchema>;

export const ReferrerDetailsSchema = z.object({
  refereesCexAccountCount: z.number(),
  totalTradedVolume: z.number(),
  statusRepartition: z.record(z.nativeEnum(REFERRAL_STATUS), z.number()),
  tradedVolumesByReferee: z.record(z.string(), z.number()),
  referralRewardsByReferee: z.record(z.string(), DecimalSchema),
});

export type ReferrerDetails = z.infer<typeof ReferrerDetailsSchema>;

export const ActiveRefereesSchema = z.record(z.string(), z.number());
export type ActiveRefereesDto = z.infer<typeof ActiveRefereesSchema>;

export const ReferralStatusRateSchema = z.object({
  totalReferrals: z.number(),
  countByStatus: z.record(z.nativeEnum(REFERRAL_STATUS), z.number()),
});
export type ReferralStatusRateDto = z.infer<typeof ReferralStatusRateSchema>;
